export type AccountVerification = {
  identityVerified: boolean;
  verifiedProfessions: string[];
};

/** Narrow public account projections; missing trust fields never grant a badge. */
export function accountVerificationFrom(value: unknown): AccountVerification {
  if (typeof value !== "object" || value === null) return { identityVerified: false, verifiedProfessions: [] };
  return {
    identityVerified: "identityVerified" in value && value.identityVerified === true,
    verifiedProfessions: "verifiedProfessions" in value && Array.isArray(value.verifiedProfessions)
      ? [...new Set(value.verifiedProfessions
        .filter((profession: unknown): profession is string => typeof profession === "string" && profession.trim().length > 0)
        .map((profession: string) => profession.trim()))]
      : [],
  };
}
